import { BreakpointObserver } from '@angular/cdk/layout';
import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { Subscription } from 'rxjs';
import { BrokerProfileService } from '../../broker-profile/broker-profile.service';
import { FilterValue } from '../search-filter/model/filter-value.model';

@Component({
  selector: 'lps-search-filter-wrapper',
  templateUrl: './search-filter-wrapper.component.html',
  styleUrls: ['./search-filter-wrapper.component.scss']
})
export class SearchFilterWrapperComponent implements OnInit, OnDestroy {

  filterValue: FilterValue;
  isMobile: boolean;
  isDropdownOpen: boolean;
  isDrawerOpen: boolean;
  filterTotal: number;
  @Output() filterHasChanged = new EventEmitter();
  @Input() showOperationType: boolean;

  breakPointSubsc = new Subscription();

  constructor(
    private breakPoint: BreakpointObserver,
    private brokerProfileService: BrokerProfileService
  ) { }

  ngOnInit() {
    this.filterValue = this.brokerProfileService.filter.getFilterValue();
    this.listenBreakPoint();
    this.filterCount(this.filterValue);
  }

  ngOnDestroy() {
    this.breakPointSubsc.unsubscribe();
  }

  changeFilter(filter: FilterValue) {
    this.filterValue = filter;
    this.brokerProfileService.filter.setValues(filter);
    this.brokerProfileService.filter.setPage(1);
    this.filterHasChanged.emit();
    this.filterCount(filter);
    this.close();
  }

  listenBreakPoint(): void {
    this.breakPointSubsc = this.breakPoint.observe(['(max-width: 768px)'])
      .subscribe((state) => {
        this.isMobile = state.matches;
        this.isDrawerOpen = false;
        this.isDropdownOpen = false;
      });
  }

  filterCount(filter: FilterValue) {
    this.filterTotal = 0;
    // tslint:disable-next-line: forin
    for (const key in filter) {
      if (key === 'dealType') {
        this.filterTotal += 1;
        continue;
      }
      if (key === 'productTypes') {
        if (filter[key]?.length) {
          this.filterTotal += filter[key].length - 1;
        }
        continue;
      }
      if (key === 'characteristics') {
        const v = filter[key].filter((x) => Array.isArray(x.value) ? x.value.length : x.value);
        this.filterTotal += v.length;
        continue;
      }

      if (Array.isArray(filter[key])) {
        this.filterTotal += filter[key].length;
      }  else if (!this.checkEmptyObjectProperties(filter[key])) {
        this.filterTotal += 1;
      }
    }
  }

  toggle(open: boolean) {
    if (this.isMobile) {
      this.isDrawerOpen = open;
      this.isDropdownOpen = false;
    } else {
      this.isDropdownOpen = open;
      this.isDrawerOpen = false;
    }
  }

  close() {
    this.isDrawerOpen = false;
    this.isDropdownOpen = false;
  }

  checkEmptyObjectProperties(obj) {
    for (const key in obj) {
      if (!Array.isArray(obj[key]) && obj[key] instanceof Object === true && typeof obj[key] !== null) {
        // if object, do recursion
        if (this.checkEmptyObjectProperties(obj[key]) === false) { return false; }
      } else {
        // check for empty values
        if (obj[key] !== null && obj[key] !== undefined && String(obj[key]) !== '') {
          return false;
        }
      }
    }
    return true;
  }

}
